import http from './_http'

const Dashboard = (m) => { return http.post(`/dashboard`, m); }
const Dashboard_Call = (a, b, c) => Dashboard({target: a, cmd : b, body: c});

const dashboard = { Dashboard, Dashboard_Call}


export default dashboard
export { Dashboard, Dashboard_Call }